import { CardContent, Divider } from "@mui/material";
import React from "react";

export const ContentRu = () => {
    return (
        <CardContent className="space-y-6 p-6 text-sm leading-relaxed">
            <div className="text-center space-y-1">
                <h1 className="text-xl font-bold">ДОГОВОР ПУБЛИЧНОЙ ОФЕРТЫ</h1>
                <p>на участие в электронной торговой платформе "Электронно торговая площадка"</p>
                <p><strong>Местоположение:</strong> Косшы, Республика Казахстан</p>
                <p><strong>Версия:</strong> 15.05.2025</p>
            </div>

            <Divider />

            <p>
                Настоящий документ представляет собой публичную оферту (далее — «Договор»),
                предлагаемую ТОО «Электронно торговая площадка» (далее — «Оператор»), в лице Генерального директора
                _, действующего на основании Устава, любому юридическому лицу или
                индивидуальному предпринимателю (далее — «Участник»), желающему получить доступ к
                услугам электронной торговой платформы «Электронно торговая площадка».
            </p>

            <p>
                Акцепт настоящей оферты считается совершённым при выполнении Участником любого из следующих действий:
                <ul className="list-disc pl-6 mt-2">
                    <li>
                        Прохождение процедуры регистрации на платформе Электронно торговая площадка по адресу <a
                            className="text-blue-600 underline" href="https://fincome.kz/"
                            target="_blank" rel="noopener noreferrer">https://fincome.kz/</a> и
                        предоставление подписанной регистрационной формы (Приложение 1);
                    </li>
                    <li>
                        Регистрация на платформе Электронно торговая площадка и оплата согласно выставленному счёту (Приложение 2).
                    </li>
                </ul>
            </p>

            <Divider />
            <h2 className="text-lg font-semibold">1. ОПРЕДЕЛЕНИЯ</h2>
            <p>Все термины, используемые в настоящем Договоре, трактуются в соответствии с настоящим разделом или Глоссарием, размещённым на официальном сайте платформы Электронно торговая площадка.</p>

            <h2 className="text-lg font-semibold">2. ПРЕДМЕТ ДОГОВОРА</h2>
            <p>Оператор предоставляет Участнику доступ к функционалу электронной торговой платформы Электронно торговая площадка (далее — «Платформа») в соответствии с действующими тарифами (Приложение 3). Участник обязуется соблюдать правила Платформы (Приложение 2) и условия настоящего Договора.</p>

            <h2 className="text-lg font-semibold">3. ПРАВА И ОБЯЗАННОСТИ СТОРОН</h2>
            <h3 className="font-medium">3.1 Обязанности Оператора:</h3>
            <ul className="list-disc pl-6">
                <li>Предоставлять доступ к функционалу Платформы;</li>
                <li>Обеспечивать целостность данных, конфиденциальность и техническую поддержку;</li>
                <li>Уведомлять Участников об изменениях правил или тарифов не менее чем за 5 рабочих дней;</li>
                <li>Предоставлять документацию, отчётность и сопровождение в соответствии с действующим законодательством и стандартами.</li>
            </ul>

            <h3 className="font-medium">3.2 Обязанности Участника:</h3>
            <ul className="list-disc pl-6">
                <li>Предоставлять достоверную и актуальную информацию;</li>
                <li>Использовать Платформу исключительно в рамках законных и разрешённых целей;</li>
                <li>Соблюдать конфиденциальность, защищать данные и придерживаться принципов честной торговли;</li>
                <li>Выполнять все финансовые и регуляторные обязательства в соответствии с правилами Платформы.</li>
            </ul>

            <h2 className="text-lg font-semibold">4. ФИНАНСОВЫЕ УСЛОВИЯ</h2>
            <ul className="list-disc pl-6">
                <li>Все тарифы и условия оплаты размещаются на официальном сайте.</li>
                <li>Дополнительные услуги, такие как аналитика, расширенный доступ и пр., могут оплачиваться отдельно.</li>
                <li>Все транзакции, счета и документы обрабатываются в электронном виде.</li>
                <li>Возврат средств осуществляется в течение 10 рабочих дней при соблюдении установленных условий.</li>
            </ul>

            <h2 className="text-lg font-semibold">5. ОТВЕТСТВЕННОСТЬ</h2>
            <ul className="list-disc pl-6">
                <li>Стороны несут ответственность в соответствии с законодательством Республики Казахстан.</li>
                <li>Оператор не несёт ответственности за убытки, вызванные техническими сбоями со стороны Участника или несоблюдением требований Платформы.</li>
                <li>Участник несёт ответственность за конфиденциальность регистрационных данных и достоверность размещённой информации.</li>
            </ul>

            <h2 className="text-lg font-semibold">6. ОБСТОЯТЕЛЬСТВА НЕПРЕОДОЛИМОЙ СИЛЫ</h2>
            <p>К форс-мажору относятся стихийные бедствия, вооружённые конфликты, действия органов власти и иные непредвиденные обстоятельства. Сторона, пострадавшая от форс-мажора, обязана уведомить другую сторону в течение 3 рабочих дней.</p>

            <h2 className="text-lg font-semibold">7. КОНФИДЕНЦИАЛЬНОСТЬ</h2>
            <p>Стороны обязуются не разглашать коммерческую тайну, техническую информацию и финансовые условия. Это обязательство действует в течение 3 лет после прекращения Договора.</p>

            <h2 className="text-lg font-semibold">8. СРОК ДЕЙСТВИЯ И РАСТОРЖЕНИЕ</h2>
            <ul className="list-disc pl-6">
                <li>Договор действует до конца текущего календарного года и автоматически продлевается, если ни одна из сторон не уведомит другую о расторжении не менее чем за 30 дней до истечения срока.</li>
                <li>Оператор вправе приостановить или расторгнуть Договор в случае неуплаты или нарушения условий.</li>
                <li>Все изменения публикуются на сайте. Участник может выразить несогласие в течение 5 дней. Отсутствие возражений считается согласием.</li>
            </ul>

            <h2 className="text-lg font-semibold">9. РАЗРЕШЕНИЕ СПОРОВ</h2>
            <p>Все споры разрешаются путём направления письменной претензии с обязательным ответом в течение 15 рабочих дней. При недостижении соглашения спор передаётся в суд по месту регистрации Оператора.</p>

            <h2 className="text-lg font-semibold">10. ПРИЛОЖЕНИЯ</h2>
            <ul className="list-disc pl-6">
                <li>Приложение 1: Регистрационная форма</li>
                <li>Приложение 2: Регламент Платформы</li>
                <li>Приложение 3: Тарифные планы</li>
            </ul>

            <p className="italic text-gray-600">
                Настоящий Договор соответствует международной практике публичных оферт и стандартам электронной торговли, включая Типовой закон ЮНСИТРАЛ об электронной торговле, ISO 20400 (устойчивые закупки) и Общий регламент по защите данных (GDPR).
            </p>
        </CardContent>
    );
}